module.exports = __webpack_public_path__ + "media/images/game/resources/money_small-3c8f4b857602f63e4122fb0be9ccb1b4.png";